import api from '@/helpers/api'

const API_READ=`/api/level/`
const API_UPDATE=API_READ
const API_CREATE=API_READ
const API_DELETE=API_READ

export default {
  namespaced:true,
  state: {
    status: '',
    levels:[],
    currUser: {},
    errMessage: '',
    meta:{
        limit:10,
        page:1,
        total:1
    }
  },
  mutations: {
    request(state){
        state.status = 'loading'
    },
    success(state){
        state.status = 'success'
    },
    error(state, {message}){
        state.status = 'error'
        state.errMessage = message
    },
    read(state, {levels}){
        state.levels = [... levels]
    },
    read_single_success(state, {levels}){
        state.levels = levels
    },
    switch_page(state, {meta}){
        state.meta = {...meta}
    }
  },
  actions: {
    read({commit, state}){

        commit('request')

        const {meta} = state

        return new Promise((resolve, reject) => {
            api.request('get', API_READ, {meta})
            .then((result) => {
                commit('read',{levels:result.data.data})
                commit('switch_page', {meta: {...result.data.meta}})
                commit('success')
                return resolve(result)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)
            });
        });
    },
    read_single({commit},id){

        commit('request');

        return new Promise((resolve, reject) => {
            api.request("get", `${API_READ}${id}`)
            .then((result) => {            
                commit('success')
                return resolve(result.data.data);
            }).catch((err) => {
                commit('error', {message: err});
                return reject(err.response.data);
            });
        });
    },
    delete({commit},id){

      commit('request');

      return new Promise((resolve, reject) => {
        api.request('delete', `${API_DELETE}${id}`)
        .then((response) => {
            commit('success')
            return resolve(response.data)
        }).catch((err) => {
            commit('error', {message: err})
            return reject(err.response.data)
        });
      });
    },
    update({commit},{data}){

        commit('request');
        
        return new Promise((resolve, reject) => {
            api.request('put', `${API_UPDATE}${data.id}`, {}, data)
            .then(($request) => {
                commit('success');
                return resolve($request)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)
            });
        });
    },
    create({commit},{data}){
        
        commit('request');

        return new Promise((resolve, reject) => {
            api.request('post', API_CREATE, {}, data)
            .then((request) => {
                commit('success');
                return resolve(request)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)
            });
        });


    }
  },
  getters : {
    levels: ()=>state => state.levels,
  }
}
